/* eslint-disable import/prefer-default-export */

import creator from './creator';
import storage from '../core/storage';

import {
  HOME_FETCH_START,
  HOME_FETCH_END,
  HOME_FETCH_MORE_START,
  HOME_FETCH_MORE_END,
  HOME_SHOW_POP_UP,
  HOME_CLOSE_POP_UP,
 } from '../constants';

// 初始化
export const homeFetchStart = creator(HOME_FETCH_START)
export const homeFetchEnd = creator(HOME_FETCH_END, 'data')
export function homeFetch() {
  return async function homeFetchAction(dispatch, getState, { ds }) {
    dispatch(homeFetchStart())
    const resp = await ds.home()
    const { data } = await resp.json()
    dispatch(homeFetchEnd(data))
  }
}

// 加载更多
export const homeFetchMoreStart = creator(HOME_FETCH_MORE_START, 'tagIds')
export const homeFetchMoreEnd = creator(HOME_FETCH_MORE_END, 'data')
export function homeMoreFetch(tagIds) {
  return async function homeFetchAction(dispatch, getState, { ds }) {
    dispatch(homeFetchMoreStart(tagIds))
    const resp = await ds.homeMore(tagIds)
    const { data } = await resp.json()
    dispatch(homeFetchMoreEnd(data))
  }
}

// 弹窗
export const showPop = creator(HOME_SHOW_POP_UP)
export const closePopUp = creator(HOME_CLOSE_POP_UP)
export function closePop(url) {
  return function closePopAction(dispatch) {
    dispatch(closePopUp(url))
    storage.save({
      [url]: true,
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/home.js